import React, {useEffect, useState} from 'react';
import UniversalTable from '../UniversalTable/UniversalTable';
import WorkplacesTab from '../WorkplacesTab/WorkplacesTab';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
import {createPortal} from 'react-dom';
import CreateDepartment from '../CreateDepartment/CreateDepartment';
import './DepartmentChildren.css';
const DepartmentChildren = ({
  childrenData,
  handleContextMenu,
  selectedItems,
  selectedItemId,
  onSelectItem,
  parentDepartmentId,
  updateDepartmentData,
  deleteError,
  handleTypeActionClear,
  menuTarget,
}) => {
  const [isVisiblePopupDeportmentAdd, setIsVisiblePopupDeportmentAdd] =
    useState(false);
  const [isPopupMounted, setIsPopupMounted] = useState(false); // Управляет рендерингом в DOM
  const columns = [
    {key: 'number', title: '№'},
    {key: 'name', title: 'Наименование'},
  ];
  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
      handleTypeActionClear();
    } else {
      setExpandedRow(rowId);
    }
  };

  const data = childrenData.map((item, index) => ({
    ...item,
    number: index + 1,
    children: (
      <>
        <WorkplacesTab
          dataList={
            item.workplaces.length > 0
              ? item.workplaces.map((wp, i) => ({...wp, number: i + 1}))
              : []
          }
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          selectedItemId={selectedItemId}
          expandedRow={expandedRow}
          onSelectItem={onSelectItem}
          updateDepartmentData={updateDepartmentData}
          deleteError={deleteError}
        />

        <DepartmentChildren
          childrenData={
            item.children.length > 0
              ? item.children.map((ch, i) => ({...ch, number: i + 1}))
              : []
          }
          expandedRow={expandedRow}
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          selectedItemId={selectedItemId}
          onSelectItem={onSelectItem}
          handleRowClick={handleRowClick}
          parentDepartmentId={item.id}
          updateDepartmentData={updateDepartmentData}
          deleteError={deleteError}
          menuTarget={menuTarget}
        />
      </>
    ),
  }));

  // Управляем плавным появлением и исчезновением
  useEffect(() => {
    if (isPopupMounted) {
      const timer = setTimeout(() => setIsVisiblePopupDeportmentAdd(true), 100); // Ждем, пока попап добавится в DOM
      return () => clearTimeout(timer);
    }
  }, [isPopupMounted]);

  // После завершения анимации удаления убираем попап из DOM
  useEffect(() => {
    if (!isVisiblePopupDeportmentAdd) {
      const timer = setTimeout(() => setIsPopupMounted(false), 300); // Ждем анимацию
      return () => clearTimeout(timer);
    }
  }, [isVisiblePopupDeportmentAdd]);

  const handleClosePopup = () => {
    setIsVisiblePopupDeportmentAdd(false);
  };
  return (
    <div className='department-children'>
      <div className='workplaces-tab__header'>
        <h3 className='workplaces-tab__title'>Отделы</h3>
      </div>
      {data?.length > 0 ? (
        <UniversalTable
          data={data}
          columns={columns}
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          expandedRow={expandedRow}
          onSelectItem={onSelectItem}
          onRowClick={handleRowClick}
          deleteError={deleteError}
          menuTarget={menuTarget}
        />
      ) : (
        <p className='no-data-message'>Нет данных для отображения</p>
      )}
      <div className='workplaces-tab__wrapper-btn'>
        <ButtonRolesAction
          onClick={() => setIsPopupMounted(true)}
          className={'ButtonRolesAction_add'}
        >
          + ДОБАВИТЬ ОТДЕЛ
        </ButtonRolesAction>
        {isPopupMounted &&
          createPortal(
            <CreateDepartment
              isDepartmentFormOpen={isVisiblePopupDeportmentAdd}
              handleClose={handleClosePopup}
              selectedItemId={selectedItemId}
              parentDepartmentId={parentDepartmentId}
              updateDepartmentData={updateDepartmentData}
            />,
            document.body
          )}
      </div>
    </div>
  );
};

export default DepartmentChildren;
